import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { Schedule, User } from '@providers/index';
import { FormSchedulePage, DetailSchedulePage, DetailTaskPage } from '../';

@Component({
  selector: 'page-activity',
  templateUrl: 'page.html'
})
export class ActivityPage {

  listSchedule : any ;
  project_ids:any = [];
  loading:any;
  params:any={};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public userApi: User,
    public scheduleApi: Schedule
  ) {
    if(this.navParams.get('project_ids')!=undefined){
      this.project_ids = this.navParams.get('project_ids');
    }

  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params:any = {};
    params.project_ids = JSON.stringify(this.project_ids);

    this.scheduleApi.getActivity(params).subscribe((resp:any) => {
      this.listSchedule = resp.data;
      this.loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      this.loading.dismiss();
    });
  }

  detail(rec) {
    if(rec.task_type=='Task'){
      this.navCtrl.push(DetailTaskPage, {
        project: {},
        rec:rec
      });
    }else{
      this.navCtrl.push(DetailSchedulePage, {
        project: {},
        rec:rec
      });
    }
  
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/activity/page.ts